import SpecialSale from 'src/dispensary/specials/sale';
import { MainDispensaryLayout } from 'components/layouts/main-dispensary-layout';
import { withLayout } from 'src/components/layouts/with-layout';
import { getCacheableSearchVisibilityServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getCacheableSearchVisibilityServerSideProps;

export default withLayout(SpecialSale, MainDispensaryLayout);
